import { render, staticRenderFns } from "./SendReminderPopUp.vue?vue&type=template&id=1b267f0c&scoped=true&"
import script from "./SendReminderPopUp.vue?vue&type=script&lang=js&"
export * from "./SendReminderPopUp.vue?vue&type=script&lang=js&"
import style0 from "./SendReminderPopUp.vue?vue&type=style&index=0&id=1b267f0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b267f0c",
  null
  
)

export default component.exports